import React from 'react';
import PropTypes from 'prop-types';

import { useField } from 'react-final-form';

import {
    FormLabel,
    FormDescription,
    FormError,
} from '/components/forms/components';

const TextField = ({ name, label, required, type, description }) => {
    const { input } = useField(name, {
        type,
    });

    return (
        <div className="block is-medium with-small-margin">
            <FormLabel label={label} required={required} />
            <input className="text-field" {...input} />
            <FormDescription description={description} />
            <FormError name={name} />
        </div>
    );
};

TextField.propTypes = {
    ...FormLabel.propTypes,
    ...FormDescription.propTypes,
    name: PropTypes.string.isRequired,
    type: PropTypes.string,
};

TextField.defaultProps = {
    ...FormLabel.defaultProps,
    ...FormDescription.defaultProps,
    type: 'text',
};

export { TextField };
